import {DomainStore} from 'shared/store';
import {action, computed} from 'mobx';
import {endpoints, types} from 'main/tools';

class ExpensesPageState {
  store = new DomainStore();
  scope;

  @action async load() {
    await this.store._compose([
      endpoints.EXPENSES.NAVIGATION
    ]);

    this.scope = this.store._getSingle(types.NAVIGATION_SCOPE).tabs;
  }

  @computed get defaultPath() {
    if (this.scope.myExpenses) {
      return '/';
    } else {
      return '/expense_requests';
    }
  }
}

export default ExpensesPageState;
